import { render, staticRenderFns } from "./WorkFlowStepComponent.vue?vue&type=template&id=afb6571a&"
import script from "./WorkFlowStepComponent.vue?vue&type=script&lang=ts&"
export * from "./WorkFlowStepComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports